import React = require("react");
import { Widget, fromJSX } from "widgets-for-react";
import { Debounced } from "./debounce.state";
import { Debounce } from "./debounce.layout";

export const debounce = <a,>(value: Debounced<a> , timeout: number): Widget<a> => 
  fromJSX((setState) => 
      value.kind == 'dirty' ? (
        <Debounce
          value={value.value}
          effect={setState}
          timeout={timeout}
        />
      ) : <></>
  )